import React from 'react';
import { useTranslation } from 'react-i18next';
import { WIDGET_CARD_STYLE } from '../../../styles';
import { ReactComponent as AllDoneImage } from '../../../../../assets/dashboard/all-done.svg';
import Heading from '../../../../../generic-components/Heading';
import { CategorizationTypes } from '../../../enums';

interface IProps {
  categorizationType: CategorizationTypes.expense | CategorizationTypes.income;
  isAllCategorized: boolean;
}
export const CategorizationAllDone = ({ categorizationType, isAllCategorized }: IProps) => {
  const { t } = useTranslation('dashboardFaceliftResourcesEN');
  const mainText = isAllCategorized ? t('CATEGORIZATION_ALL_TRANSACTIONS_CATEGORIZED') : (categorizationType === CategorizationTypes.expense ? t('CATEGORIZATION_ALL_DONE.TEXT_EXPENSES') : t('CATEGORIZATION_ALL_DONE.TEXT_INCOME'));
  return (
    <div className={`${WIDGET_CARD_STYLE} relative z-30 h-[311px] pt-[40px] px-[24px]`}>
      <div className='bg-[#EAF3FF] w-[117px] h-[117px] rounded-full flex items-center justify-center'>
        <AllDoneImage data-testid='CategorizationAllDone__image' />
      </div>
      <Heading title={t('CATEGORIZATION_ALL_DONE.TITLE')} className='font-metricRBold text-bw08 text-sm leading-6 mt-[24px] mb-[12px]' testId='CategorizationAllDone__title' />
      <div data-testid='CategorizationAllDone__main-text' className='font-metricR text-bw08 text-sm leading-5 text-center'>{mainText}</div>
    </div>
  );
};
